module.exports = __webpack_public_path__ + "img/YegoBox.ec47ea6f.jpg";